import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import './Hero.scss';

export default function Hero() {
  const { t } = useI18n();
  return (
    <section className="wan-hero">
      <div className="wan-hero__content">
        <h1 className="wan-hero__title">{t('videoGeneration.wan.hero.title')}</h1>
        <p className="wan-hero__sub">{t('videoGeneration.wan.hero.sub')}</p>
        <p className="wan-hero__desc">{t('videoGeneration.wan.hero.desc')}</p>
      </div>
    </section>
  );
}